// extracted by mini-css-extract-plugin
export default {"processedfile":"ProcessedFiles_processedfile_zzpcx"};